import type { Template } from "@/types";

export const PO_05_H0_V5: Template[] = [
{
    id: "po-05-h0v5-01",
    name: "PO 01 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 84, y: 262, width: 204, height: 325, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 262, width: 204, height: 325, rotation: 0, imageRotation: 0 },
            { id: "3", x: 508, y: 262, width: 204, height: 325, rotation: 0, imageRotation: 0 },
            { id: "4", x: 720, y: 262, width: 204, height: 325, rotation: 0, imageRotation: 0 },
            { id: "5", x: 932, y: 262, width: 204, height: 325, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h0v5-02",
    name: "PO 02 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 240, width: 237, height: 372, rotation: 0, imageRotation: 0 },
        { id: "2", x: 245, y: 240, width: 237, height: 372, rotation: 0, imageRotation: 0 },
        { id: "3", x: 490, y: 240, width: 237, height: 372, rotation: 0, imageRotation: 0 },
        { id: "4", x: 735, y: 240, width: 237, height: 372, rotation: 0, imageRotation: 0 },
        { id: "5", x: 980, y: 240, width: 237, height: 372, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-03",
    name: "PO 03 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 121, y: 282, width: 181, height: 287, rotation: 0, imageRotation: 0 },
            { id: "2", x: 310, y: 282, width: 180, height: 287, rotation: 0, imageRotation: 0 },
            { id: "3", x: 636, y: 282, width: 180, height: 287, rotation: 0, imageRotation: 0 },
            { id: "4", x: 824, y: 282, width: 179, height: 287, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1011, y: 282, width: 179, height: 287, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-04",
    name: "PO 04 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 44, y: 167, width: 353, height: 517, rotation: 0, imageRotation: 0 },    
        { id: "2", x: 405, y: 167, width: 167, height: 255, rotation: 0, imageRotation: 0 },
        { id: "3", x: 405, y: 430, width: 167, height: 254, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 234, width: 252, height: 382, rotation: 0, imageRotation: 0 },
        { id: "5", x: 917, y: 234, width: 252, height: 382, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-05",
    name: "PO 05 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 81, y: 165, width: 341, height: 521, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 430, y: 165, width: 111, height: 168, rotation: 0, imageRotation: 0 },
        { id: "3", x: 430, y: 341, width: 111, height: 168, rotation: 0, imageRotation: 0 },
        { id: "4", x: 430, y: 518, width: 111, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 743, y: 165, width: 340, height: 521, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-06",
    name: "PO 06 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 94, y: 95, width: 420, height: 662, rotation: 0, imageRotation: 0 },
        { id: "2", x: 703, y: 95, width: 206, height: 327, rotation: 0, imageRotation: 0 },
        { id: "3", x: 703, y: 430, width: 206, height: 327, rotation: 0, imageRotation: 0 },
        { id: "4", x: 917, y: 95, width: 206, height: 327, rotation: 0, imageRotation: 0 },
        { id: "5", x: 917, y: 430, width: 206, height: 327, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-07",
    name: "PO 07 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 88, y: 226, width: 254, height: 397, rotation: 0, imageRotation: 0 },
        { id: "2", x: 350, y: 163, width: 167, height: 258, rotation: 0, imageRotation: 0 },
        { id: "3", x: 350, y: 429, width: 167, height: 258, rotation: 0, imageRotation: 0 },
        { id: "4", x: 657, y: 226, width: 253, height: 397, rotation: 0, imageRotation: 0 },
        { id: "5", x: 918, y: 226, width: 253, height: 397, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-08",
    name: "PO 08 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 87, y: 91, width: 422, height: 652, rotation: 0, imageRotation: 0 },
            { id: "2", x: 667, y: 160, width: 335, height: 514, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1010, y: 160, width: 108, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1010, y: 334, width: 108, height: 166, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1010, y: 509, width: 108, height: 165, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-09",
    name: "PO 09 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 67, y: 182, width: 304, height: 485, rotation: 0, imageRotation: 0 },
        { id: "2", x: 379, y: 182, width: 149, height: 238, rotation: 0, imageRotation: 0 },
        { id: "3", x: 379, y: 429, width: 149, height: 238, rotation: 0, imageRotation: 0 },
        { id: "4", x: 536, y: 182, width: 302, height: 485, rotation: 0, imageRotation: 0 },
        { id: "5", x: 846, y: 182, width: 302, height: 485, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h0v5-10",
    name: "PO 10 - H0V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h0_v5_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 95, y: 195, width: 287, height: 461, rotation: 0, imageRotation: 0 },
        { id: "2", x: 390, y: 195, width: 287, height: 461, rotation: 0, imageRotation: 0 },
        { id: "3", x: 685, y: 195, width: 287, height: 461, rotation: 0, imageRotation: 0 },
        { id: "4", x: 980, y: 195, width: 142, height: 227, rotation: 0, imageRotation: 0 },
        { id: "5", x: 980, y: 430, width: 142, height: 226, rotation: 0, imageRotation: 0 }
    ],
}
];